/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Wang Chao
 * @date  2021/5/24 10:20
 * @des
 */
export default {
  LESSON_ITEM_PLAY_INDEX: 'Lesson_Item_Play_Index_',//正在播放的小课视频项
  VIDEO_PLAYING: 'videoPlaying', // 正在播放的播放项
  EXAM_TOOL_DEFAULT: 'examToolDefault',//录题默认参数
  PLAY_TEMPLATE_VOICE: 'playTemplateVoice',//是否播放语音提示
  PLAY_TEMPLATE_LESSON_START: 'playTemplateLessonStart',//是否播放了课程的片头语音
  LESSON_ITEM_CONFIG: 'Lesson_Item_Config',//存储课程项相关的配置
}



// WEBPACK FOOTER //
// ./src/base/store/storagetags.js